import { Component, Input } from '@angular/core';
import { AccessDoorGroupType } from '../../models/access-door-group-type.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { AccessDoorGroupTypeService } from '../../services/access-door-group-type.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-access-door-group-type-modal',
  templateUrl: './access-door-group-type-modal.component.html',
  styleUrl: './access-door-group-type-modal.component.scss'
})
export class AccessDoorGroupTypeModalComponent {

  @Input() accessDoorGroupType?: AccessDoorGroupType;

  public dataForm: DataFormModel = {
    image: {
      value: '',
      type: 'image',
      label: '',
      required: false,
      validators: []
    },
    accessDoorGroup: {
      value: '',
      type: 'text',
      label: 'Nombre del grupo de puertas de acceso',
      requiredMessage: 'Por favor, ingrese el nombre del grupo',
      required: true,
      validators: [Validators.required]
    },
  };

  public formAccessDoorGroupType!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  public imageBase64: string | null = null;
  public selectedFile: File | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    public accessDoorGroupTypeService: AccessDoorGroupTypeService,
    public utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formAccessDoorGroupType.controls;
  } 

  async create() {

    this.formAccessDoorGroupType.value.imageBase64 = this.imageBase64;

    const flag = await this.accessDoorGroupTypeService.create(
      this.formAccessDoorGroupType.value,
      this.selectedFile ?? undefined
    );

    if (flag) {
      this.activeModal.close();
    }
  }

  async loadData() {
    this.loading = true;

    if (this.accessDoorGroupType) {
      this.dataForm = {
        ...this.dataForm,
      }

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.accessDoorGroupType!) {
          const standardKey = key as keyof typeof this.accessDoorGroupType;
          this.dataForm[key].value = this.accessDoorGroupType[standardKey]!;
        }
      }
    }
    
    this.formAccessDoorGroupType = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗██╗     ███████╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
  ██╔═══██╗████╗  ██║██╔════╝██║██║     ██╔════╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
  ██║   ██║██╔██╗ ██║█████╗  ██║██║     █████╗  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗
  ██║   ██║██║╚██╗██║██╔══╝  ██║██║     ██╔══╝  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝
  ╚██████╔╝██║ ╚████║██║     ██║███████╗███████╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
   ╚═════╝ ╚═╝  ╚═══╝╚═╝     ╚═╝╚══════╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝

  */
  /**
   * FUNCTION onFileChange
   * 
   * @param event 
   */
  onFileChange(event: any) {
    console.log(event);

    const file = event.target.files[0];
    this.selectedFile = file;

    const reader = new FileReader();
    reader.readAsDataURL(file); // toBase64
    reader.onload = () => {
      this.imageBase64 = reader.result as string; // base64 Image src
      console.log(this.imageBase64);
      
    };
    
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formAccessDoorGroupType.invalid) {
      return;
    }

    if (this.accessDoorGroupType) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async update() {
    this.formAccessDoorGroupType.value.accessDoorGroupTypeId = this.accessDoorGroupType!.accessDoorGroupTypeId;

    this.formAccessDoorGroupType.value.imageBase64 = this.imageBase64;

    const flag = await this.accessDoorGroupTypeService.update(
      this.formAccessDoorGroupType.value,
      this.selectedFile ?? undefined
    );

    if (flag) {
      this.activeModal.close();
    }
  }

}
